module.exports = __webpack_public_path__ + "img/fig06.79ba3eca.jpg";